import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'

import s from './styles.module.scss'

interface Props {
  passengersCount?: number
  outboundDate?: string
  isTimeLeft?: boolean
}

export const FavoritesWarning = ({
  passengersCount,
  outboundDate,
  isTimeLeft,
}: Props) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <div className={s.row}>
        <AppIcon
          id={AllIcons.AIRPLANE_BG}
          width={16}
          height={16}
          className={clsx(s.icon, s.blue)}
        />

        <p className={clsx('medium-12', s.text)}>
          {t('tickets_page.outbound_date', { date: outboundDate })}
        </p>
      </div>

      <div className={s.row}>
        <AppIcon
          id={AllIcons.PASSENGERS_BG}
          width={16}
          height={16}
          className={clsx(s.icon, s.blue)}
        />

        <p className={clsx('medium-12', s.text)}>
          {t('tickets_page.passengers', { count: passengersCount })}
        </p>
      </div>

      {isTimeLeft && (
        <div className={s.row}>
          <AppIcon
            id={AllIcons.TRIANGLE}
            width={16}
            height={16}
            className={clsx(s.icon, s.orange)}
          />

          <p className={clsx('medium-12', s.text)}>
            {t('favorites_block.warning.title')}
          </p>
        </div>
      )}
    </div>
  )
}
